export const platforms = [0, 1, 2, 3, 4] as const

export type Platform = (typeof platforms)[number]

export const getPlatformDisplayName = (platform: Platform) => {
  switch (platform) {
    case 0:
      return 'PC'
    case 1:
      return 'PlayStation'
    case 2:
      return 'Xbox'
    case 3:
      return 'Switch'
    case 4:
      return 'モバイル'
  }
}
